import { render, staticRenderFns } from "./paymentResult.vue?vue&type=template&id=0e84271c&scoped=true&"
import script from "./paymentResult.vue?vue&type=script&lang=ts&"
export * from "./paymentResult.vue?vue&type=script&lang=ts&"
import style0 from "./paymentResult.vue?vue&type=style&index=0&id=0e84271c&lang=less&scoped=true&"
import style1 from "./paymentResult.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e84271c",
  null
  
)

component.options.__file = "paymentResult.vue"
export default component.exports